import React from 'react'
import { Outlet } from 'react-router-dom'

import { Box, Button, Tabs } from '@factorialco/deprecated-design-system'
import { GetAllBudgetsCountDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { BudgetList } from 'modules/finance/components/Budgets/List'
import BudgetsLanding from 'modules/finance/components/Budgets/List/BudgetsLanding'
import { events } from 'modules/finance/lib/events'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const TABS = {
  active: 'active',
  archive: 'archive',
}

const BudgetListPage = () => {
  const { navigation } = useNavigation()
  const [tab, setTab] = React.useState(TABS.active)

  const { data, error, loading } = useQuery(GetAllBudgetsCountDocument, {})

  const totalBudgets = data?.finance.budgetsConnection.totalCount ?? 0

  const canSeeBudgets = data?.finance._policies.budgetsSeeBudgets.can ?? false
  const canCreateBudgets = data?.finance._policies.budgetsCreateBudgets.can ?? false
  const canManageBudgets = data?.finance._policies.budgetsManageBudgets.can ?? false

  return (
    <ResponsivePage.Body variant="full" loading={loading} error={error} authorized={canSeeBudgets}>
      {totalBudgets === 0 && <BudgetsLanding />}
      {totalBudgets > 0 && (
        <>
          {canCreateBudgets && (
            <Box alignItems="flexEnd">
              <Button.Router
                iconName="add"
                to={navigation.expenses.budgets.list.new.fullPath()}
                onClick={() => {
                  track(events.clickAddBudget)
                }}
              >
                {i18n.t('budgets.navbar.add_budget')}
              </Button.Router>
            </Box>
          )}
          <Tabs currentId={tab} onTabClicked={setTab}>
            <Tabs.Tab id={TABS.active} label={i18n.t('budgets.list.tabs.active')}>
              <Box paddingTop="s24">
                <BudgetList canManageBudgets={canManageBudgets} />
              </Box>
            </Tabs.Tab>
            <Tabs.Tab id={TABS.archive} label={i18n.t('budgets.list.tabs.archive')}>
              <Box paddingTop="s24">
                <BudgetList canManageBudgets={canManageBudgets} archived />
              </Box>
            </Tabs.Tab>
          </Tabs>
        </>
      )}

      <Outlet />
    </ResponsivePage.Body>
  )
}
export default BudgetListPage
